import React from 'react';
import { Grid, TextField, MenuItem } from '@mui/material';
import { Student } from '@/types';
import { IMMUNIZATION_STATUS } from '../../StudentForm/constants';

interface HealthSectionProps {
  values: Partial<Student>;
  onChange: (id: keyof Student, value: any) => void;
}

export const HealthSection: React.FC<HealthSectionProps> = ({
  values,
  onChange
}) => {
  const handleChange = (field: keyof Student) => (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    onChange(field, event.target.value);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          rows={3}
          label="Allergies"
          value={values.allergies || ''}
          onChange={handleChange('allergies')}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          rows={3}
          label="Medical Conditions"
          value={values.medicalConditions || ''}
          onChange={handleChange('medicalConditions')}
        />
      </Grid>

      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          rows={3}
          label="Medications"
          value={values.medications || ''}
          onChange={handleChange('medications')}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          select
          label="Immunization Status"
          value={values.immunizationStatus || ''}
          onChange={handleChange('immunizationStatus')}
        >
          {IMMUNIZATION_STATUS.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Emergency Contact Name"
          value={values.emergencyContactName || ''}
          onChange={handleChange('emergencyContactName')}
          required
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Emergency Contact Phone"
          value={values.emergencyContactPhone || ''}
          onChange={handleChange('emergencyContactPhone')}
          required
        />
      </Grid>
    </Grid>
  );
};